import VueCookies from "vue-cookies";
import env from "@/environment";

declare global {
  interface Window {
    $cookies: any;
  }
}
window.$cookies = VueCookies; 

const cookieOpts = {
  domain: env.cookiesDomain,
  secure: env.name !== "development",
  path: "/",
  sameSite: "lax" as const,
};

export function saveAuthToken(token: string) {
  localStorage.setItem("AUTH_TOKEN", token);
  window.$cookies.set("AUTH_TOKEN", token, cookieOpts);
}

export function getAuthToken(): string | null {
  return window.$cookies.get("AUTH_TOKEN");
}

export function removeAuthToken(): void {
  window.$cookies.remove("AUTH_TOKEN", cookieOpts);
  localStorage.removeItem("AUTH_TOKEN");
}